// core
import React from 'react';
import { Link } from 'react-router-dom'

// settings + utils
import Settings from 'config.js';
import Auth from 'services/Auth.js';
import API from 'utils/API.js';
import CSV from 'utils/CSV.js';

// lib
import Page from 'pages/shared/Page';
import Spinner from 'components/shared/Spinner';

// shared
import PageHeader from 'components/shared/PageHeader';
import ButtonsToolbar from 'components/shared/ButtonsToolbar';
import FiltersToolbar from 'components/shared/filters/FiltersToolbar';
import SortingToolbar from 'components/shared/SortingToolbar';

import MainHeading from 'components/shared/MainHeading';
import PageDataWrapper from 'pages/shared/PageDataWrapper.js';

// page-specific/etc.
// import Filters from 'components/kit-orders/details/Filters';
import KitOrdersList from 'components/kit-orders/details/KitOrdersList';

let getYYYYMMDD = (ts) => {
  let a = new Date(ts);
  let months = ['01','02','03','04','05','06','07','08','09','10','11','12'];
  let year = a.getFullYear();
  let month = months[a.getMonth()];
  let date = a.getDate() < 10 ? ('0' + a.getDate()) : a.getDate();
  let hour = a.getHours();
  let min = a.getMinutes();
  let sec = a.getSeconds();

  return year + '-' + month + '-' + date;
};

let tsMinusDays = (now, days) => {
  return now - 1000 * 60 * 60 * 24 * days;
};

class KitOrdersOverviewPage extends React.Component {
  constructor(props) {
    super(props);

    this.MIN_PROBLEMS_YEAR = 2017; // don't fetch problems before this year

    this.state = {
      // XHR stuff
      queue: {},
      fetching: false,
      error: '',

      // filters
      filters: {
        schoolyears: [],

        locations: [],

        projects: [],
        productGroups: [],
        products: [],

        operators: ['AND', 'AND']
      },
      showFiltersRestoreNotice: false,
      searchKey: '',

      // this is the object(s) before any filtering/search
      fetchedData: {
        orders: {
          byDate: {// all orders in the last 15, 30, 90 days or all time
            15: [],
            30: [],
            90: [],
            5000: []
          }
        }
      },

      // current object(s)
      currData: {
        orders: [],

        sortBy: 'id',
        sortDir: 'ASC',

        // offset: 0,
        // limit: 500
      },

      // etc.
      kit: {},
      problems: null,

      numDays: 0,
      enabledTabs: [],
    };

    this.handleNumDays = this.handleNumDays.bind(this);
    this.handleFilters = this.handleFilters.bind(this);
    this.handleSearchUpdate = this.handleSearchUpdate.bind(this);
    this.refreshOrders = this.refreshOrders.bind(this);
    this.handleSortingChange = this.handleSortingChange.bind(this);
    this.sort = this.sort.bind(this);

    this.handleEdit = this.handleEdit.bind(this);

    this.downloadCSV = this.downloadCSV.bind(this);
  }

  componentWillMount() {
    const currFiltersJSON = window.localStorage.getItem('colibri:kit-orders:filters');
    if (currFiltersJSON) {
      const currFilters = JSON.parse(currFiltersJSON);

      this.setState({
        filters: currFilters,
        showFiltersRestoreNotice: true
      }, () => {
        window.setTimeout(() => {
          this.setState({
            showFiltersRestoreNotice: false
          });
        }, 2000);
      });
    }
  }

  componentDidMount() {
    // get kit
    const kitId = this.props.match.params.kitId;
    if (!kitId) {
      alert('unknown kit ID');

      return false;
    }

    const kit = this.props.appData.cache.kitsById[kitId];
    if (!kit) {
      alert('cannot find kit!');

      return false;
    }

    this.setState((prevState) => {
      prevState.kit = kit;

      return prevState;
    });

    // get orders (will get orders in the last 15 days in all locations and set as default, then load the other ones)
    this.setState({
      fetching: true
    });

    const now = (new Date()).getTime();
    const endpoint = Settings.V3_API_URL + '/reports/orders/by-kit/' + kitId;
    API.call('GET', endpoint, {
      access_token: Auth.getToken(),

      offset: 0,
      limit: -1,

      date_from: getYYYYMMDD(tsMinusDays(now, 15)),
      date_to:  getYYYYMMDD(now)
    }, (response, error) => {
      if (error) {
        console.dir(error);

        this.setState({
          fetching: false,
          error: error.message + ' while getting kit orders'
        });

        return false;
      }

      this.setState((prevState) => {
        prevState.fetching = false;
        prevState.numDays = 15;
        prevState.enabledTabs.push(15);
        prevState.fetchedData.orders = {
          byDate: {
            15: response.data.report.orders
          }
        };

        return prevState;
      }, () => {
        this.refreshOrders();
      });

      // now, load everything else
      [30, 90, 5000].forEach((numDays) => {
        API.call('GET', endpoint, {
          access_token: Auth.getToken(),

          offset: 0,
          limit: -1,

          date_from: getYYYYMMDD(tsMinusDays(now, numDays)),
          date_to: getYYYYMMDD(now)
        }, (response, error) => {
          if (error) {
            console.dir(error);

            this.setState({
              fetching: false,
              error: error.message + ' while getting kit orders'
            });

            return false;
          }

          this.setState((prevState) => {
            prevState.fetchedData.orders.byDate[numDays] = response.data.report.orders;
            prevState.enabledTabs.push(numDays);

            return prevState;
          });
        });
      });
    });
  }

  handleNumDays(numDays) {
    this.setState((prevState) => {
      prevState.numDays = numDays;

      return prevState;
    }, () => {
      this.refreshOrders();
    });
  }

  handleFilters(data) {
    this.setState({
      filters: data
    }, () => {
      // save for later
      const currFiltersJSON = JSON.stringify(data);
      window.localStorage.setItem('colibri:kit-orders:filters', currFiltersJSON);

      this.refreshOrders();
    });
  }

  handleSearchUpdate(searchKey, e) {
    this.setState((prevState) => {
      prevState.searchKey = searchKey;

      return prevState;
    }, () => {
      this.refreshOrders();
    });
  }

  handleSortingChange(sortBy, sortDir) {
    this.setState((prevState) => {
      prevState.currData.sortBy = sortBy;
      prevState.currData.sortDir = sortDir;

      return prevState;
    }, () => {
      this.refreshOrders();
    });
  }

  sort(items) {
    if (!this.state.currData.sortBy || !this.state.currData.sortDir) {
      alert('do NOT know how to sort :-/');

      return items;
    }

    let stringBased;

    items.sort((itemA, itemB) => {
      let a = '';
      let b = '';

      switch (this.state.currData.sortBy) {
        // handle special cases
        case 'school_name':
          a = itemA.school ? itemA.school.name : '';
          b = itemB.school ? itemB.school.name : '';
          stringBased = true;
          break;
        case 'school_city':
          a = itemA.school ? itemA.school.city_name : '';
          b = itemB.school ? itemB.school.city_name : '';
          stringBased = true;
          break;
        case 'school_province':
          a = itemA.school ? itemA.school.province_name: '';
          b = itemB.school.province_name;
          stringBased = true;
          break;
        case 'school_region':
          a = itemA.school ? itemA.school.region_name: '';
          b = itemB.school ? itemB.school.region_name: '';
          stringBased = true;
          break;
        case 'teacher_name':
          a = itemA.teacher ? itemA.teacher.first_name + ' ' + itemA.teacher.last_name: '';
          b = itemB.teacher ? itemB.teacher.first_name + ' ' + itemB.teacher.last_name: '';
          stringBased = true;
          break;
        case 'teacher_subject':
          a = itemA.teacher ? itemA.teacher.subject + ' ' + itemA.teacher.subject: '';
          b = itemB.teacher ? itemB.teacher.subject + ' ' + itemB.teacher.subject: '';
          stringBased = true;
          break;
        case 'students_num_students':
          a = 0;
          b = 0;
          itemA.items.forEach((item) => {
            a += item.schoolclass_num_students;
          });
          itemB.items.forEach((item) => {
            b += item.schoolclass_num_students;
          });
          stringBased = false;
          break;

        // handle everything else
        case 'id':
        case 'item_shippability':
        case 'item_status':
        case 'item_shipped_on':
          a = itemA.teacher ? itemA.teacher.subject + ' ' + itemA.teacher.subject: '';
          b = itemB.teacher ? itemB.teacher.subject + ' ' + itemB.teacher.subject: '';
          stringBased = true;
          break;

        // WTF!?
        default:
          alert('Wrong sorting prop, will die');

          return false;
      }

      // normalize
      if (stringBased) {
        a = a ? String(a) : '';
        b = b ? String(b) : '';
        a = a.trim();
        b = b.trim();
        a = a.toLowerCase();
        b = b.toLowerCase();
      }

      console.log('A: ' + a);
      console.log('B: ' + b);

      if (a < b){
        return -1;
      }
      if (a > b){
        return 1;
      }

      return 0;
    });

    if (this.state.currData.sortDir == 'DESC') {
      items = items.reverse();
    }

    return items;
  }

  refreshOrders() {
    const numDays = this.state.numDays;
    if (!this.state.fetchedData.orders || !this.state.fetchedData.orders.byDate[numDays]) {
      console.log('No orders in fetchedData');

      return;
    }

    // apply filters to orders
    let orders = [];
    this.state.fetchedData.orders.byDate[numDays].forEach((order) => {
      let locationOK = false;
      let searchOK = false;

      if (!this.state.filters.locations.length) {
        locationOK = true;
      } else {
        this.state.filters.locations.forEach((location) => {
          if (order.school_region_id == location || order.school_province_id == location || order.school_city_id == location) {
            locationOK = true;
          }
        });
      }

      if (this.state.searchKey == '') {
        searchOK = true;
      } else {
        const searchKey = this.state.searchKey.toLowerCase();

        if (
          String(order.school_id).toLowerCase().indexOf(searchKey) != -1 ||
          String(order.school_name).toLowerCase().indexOf(searchKey) != -1 ||
          String(order.school_email).toLowerCase().indexOf(searchKey) != -1 ||
          String(order.school_certified_email).toLowerCase().indexOf(searchKey) != -1 ||

          String(order.teacher_first_name).toLowerCase().indexOf(searchKey) != -1 ||
          String(order.teacher_last_name).toLowerCase().indexOf(searchKey) != -1 ||
          String(order.teacher_email).toLowerCase().indexOf(searchKey) != -1
        ) {
          searchOK = true;
        }
      }

      if (locationOK && searchOK) {
        orders.push(order)
      }
    });

    // sort
    orders = this.sort(orders);

    this.setState((prevState) => {
      prevState.currData.orders = orders;

      return prevState;
    });
  }

  handleEdit(order) {
    const url = '/kits/' + this.state.kit.id + '/orders/' + order.id + '/';

    this.props.history.push(url);
  }
  downloadCSV() {
    console.log('+++++++++++++++++++++++++++++');
    console.dir(this.state.currData.orders);


    if (!this.state.currData.orders || !this.state.currData.orders.length) {
      return;
    }

    const filename = 'Richieste kit_' + this.state.kit.name + '_' + this.state.kit.schoolyear + '_' + (new Date()).toISOString() + '.csv';

    const payload = {
      access_token: Auth.getToken(),

      table_name: 'kit_order_items_data',
      primary_key: 'order_id',
      ids: this.state.currData.orders.map((order) => {
        return order.id;
      })
    };
    const endpoint = Settings.V3_API_URL + '/reports/data/export/csv';
    API.call('POST', endpoint, payload, (response, error) => {
      if (error) {
        console.dir(error);

        this.setState({
          fetching: false,
          error: error.message + ' while getting kit orders'
        });

        return false;
      }

      const csv = response.data.csv_data;
      CSV.serveCSV(csv, filename);
    });


    // let items = [];
    // this.state.currData.orders.forEach((order) => {
    //   order.items.forEach((item) => {
    //     console.log('Handle item #' + item.id)
    //     let itemData = Object.assign({}, item);

    //     ['school', 'teacher', 'user_provided_school'].forEach((dataType) => {
    //       if (order[dataType]) {
    //         let o = {};

    //         Object.keys(order[dataType]).forEach((key) => {
    //           o[dataType + '_' + key] = order[dataType][key];
    //         });

    //         itemData = Object.assign(itemData, o);
    //       }
    //     });

    //     items.push(itemData);
    //   });
    // });

    // CSV.export(filename, items, ';');

    // console.dir(items);
    console.log('+++++++++++++++++++++++++++++');
  }

  render() {
    const { kitId } = this.props.match.params;

    let mainHeadingTitle = this.state.kit ? this.state.kit.name : <Spinner message="Recupero info kit..." />;
    let dataLabel;
    let dataDescr;

    if (!this.state.numDays || !this.state.fetchedData.orders.byDate[this.state.numDays] || !this.state.currData.orders) {
      dataLabel = <Spinner message="Recupero ordini..." />;
      dataDescr = '';
    } else {
      // add type of query
      if (this.state.numDays == 5000) {
        dataLabel = 'Ordini totali';
      } else {
        dataLabel = 'Ordini negli ultimi ' + this.state.numDays + ' giorni';
      }

      dataDescr = '';
      // add locations
      if (this.state.filters.locations && this.state.filters.locations.length) {
        dataDescr += ' in ' + this.state.filters.locations.map((loc) => {
         if (this.props.appData.cache.locationsById[loc]) {
           return this.props.appData.cache.locationsById[loc].name;
         }
        }).join(', ');
      }

      // add search key
      if (this.state.searchKey) dataDescr += ' con "' + this.state.searchKey + '"';

      // add numbers
      dataDescr += ' (';
      if (this.state.currData.orders.length != this.state.fetchedData.orders.byDate[this.state.numDays].length) {
        dataDescr += this.state.currData.orders.length + ' su ' + this.state.fetchedData.orders.byDate[this.state.numDays].length;
      } else {
        dataDescr += this.state.currData.orders.length;
      }
      dataDescr += ')';
    }

    let related = [];
    // if (this.state.kit.schoolyear >= this.MIN_PROBLEMS_YEAR) {
    //   if (this.state.problems) {
    //     if (this.state.problems.num_problems > 0) {
    //       related.push({
    //         label: 'Problemi (' + (this.state.problems ? this.state.problems.num_problems : '0') + ')',
    //         href: "/kit-orders/" + kitId + "/problems/?back=details",
    //         type: 'error'
    //       });
    //     }
    //   } else {
    //     // still checking
    //     related.push({
    //       label: 'Controllo problemi...',
    //       href: "",
    //       type: 'default',
    //       icon: 'fa fa-circle-notch fa-spin'
    //     });
    //   }
    // }

    // handle related links
    related.push({
      label: 'Spedizioni',
      href: "/kit-orders/" + kitId + "/shipping/",
      type: 'default',
      icon: 'fa fa-truck'
    });

    // handle num days tabs
    let tabs = [[], []];
    [15, 30, 90, 5000].forEach((numDays) => {
      let tabGroup = numDays != 5000 ? 0 : 1;
      let status = '';
      let label = numDays == 5000 ? 'Tutti' : 'Ultimi ' + numDays + ' gg.';
      if (numDays == this.state.numDays) {
        status = 'active';
      } else {
        status = this.state.enabledTabs.indexOf(numDays) != -1 ? 'default' : 'busy';
      }

      const numOrders = this.state.fetchedData.orders.byDate[numDays] ? this.state.fetchedData.orders.byDate[numDays].length : '?';

      tabs[tabGroup].push({
        label: status == 'busy' ? <span><Spinner /> {label}</span> : label + ' (' + numOrders + ')',
        status,
        onClick: status == 'busy' ? null : (e) => {
          this.handleNumDays(numDays);
        },
        numDays: numDays
      });
    });

    return (
      <div>
        <PageHeader>
          <ButtonsToolbar
            back={{
              label: 'torna all\'overview richieste',
              href: '/kits/overview/'
            }}

            related={related}
          />
          <MainHeading
            icon={null}
            title={mainHeadingTitle}
            descr=""
          />
        </PageHeader>

        <div className={'container animated ' + (this.state.showFiltersRestoreNotice ? 'fadeInDown' : 'fadeOutUp')}>
          <div className="row">
            <div className="col-12">
            <div className="popover fade bs-popover-top show" style={{position: 'absolute', top: '-55px', left: '15px'}}>
              <div className="arrow" style={{left: '50px'}}></div>

              <div class="popover-body">
                <i className="fa fa-check text-success" style={{fontSize: '20px', float: 'left', marginRight: '12px', marginTop: '10px'}} /> Filtri ripristinati come da ultima sessione di lavoro
              </div>
              </div>
            </div>
          </div>
        </div>

        <FiltersToolbar
          filters={['locations']}
          collapsable={false}

          onChange={this.handleFilters}

          data={this.state.filters}
          appData={this.props.appData}
        />

        <SortingToolbar
          options={[
            {
              label: 'id',
              name: 'id'
            },
            {
              label: 'Scuola/ nome',
              name: 'school_name'
            },
            {
              label: 'Scuola/ città',
              name: 'school_city'
            },
            {
              label: 'Scuola/ provincia',
              name: 'school_province'
            },
            {
              label: 'Scuola/ regione',
              name: 'school_region'
            },
            {
              label: 'Insegnante/ nome',
              name: 'teacher_name'
            },
            {
              label: 'Insegnante/ materia',
              name: 'teacher_subject'
            },
            {
              label: 'Alunni/ numero alunni',
              name: 'students_num_students'
            },
            {
              label: 'Ordine/ spedibilità',
              name: 'order_shippability'
            },
            {
              label: 'Ordine/ stato',
              name: 'order_status'
            },
            {
              label: 'Ordine/ spedito il',
              name: 'order_shipped_on'
            }
          ]}
          sortBy={this.state.currData.sortBy}
          sortDir={this.state.currData.sortDir}

          onChange={this.handleSortingChange}
        />

        <div className="container mt-2 mb-3">
          {
            tabs.map((groups) => {
              return (
                <div className="btn-group mr-2">
                  {
                    groups.map((button) => {
                      return (
                        <button
                          className={'btn ' + (button.status == 'active' ? 'btn-primary' : 'btn-secondary') + (button.status == 'busy' ? ' disabled' : '')}
                          onClick={button.onClick}
                        >
                          {button.label}
                        </button>
                      );
                    })
                  }
                </div>
              );
            })
          }
        </div>

        <PageDataWrapper
          appData={this.props.appData}

          data={{
            label: dataLabel,
            descr: dataDescr,

            onExport: this.state.currData.orders && this.state.currData.orders.length > 0 ? this.downloadCSV : null
          }}
          search={{
            placeholder: 'Cerca tra i risultati',
            onChange: this.handleSearchUpdate,
            onSubmit: this.handleSearchUpdate
          }}
          filters={{
            tabs
          }}
          status={{
            fetching: this.state.fetching,
            errors: null
          }}
        >
          {
            this.state.error ? (
              <div className="alert alert-danger"><h2>Oh, mamma!</h2><p>{this.state.error}</p></div>
            ) : (
              <div className="mt-4">
                {this.state.currData.orders.length ? <KitOrdersList orders={this.state.currData.orders} onEdit={this.handleEdit} /> : <h3><i className="far fa-frown" /> Nessun ordine</h3>}
              </div>
            )
          }
        </PageDataWrapper>
      </div>
    );
  }
}

export default KitOrdersOverviewPage;



// WEBPACK FOOTER //
// ./src/pages/kit-orders/KitOrdersOverviewPage.js